export default {
    BASE_URL: "https://api.abtexchange.vip",
    BASE_WSS: "wss://ws.abtexchange.vip",
    BASE_IO: "wss://ws.abtexchange.vip",


    DOMAIN: "https://h5.abtexchange.vip",
    HELP_URL: "https://help.abtexchange.vip"
}